module.exports = __webpack_public_path__ + "img/screenshot1-phone.e3b91ca0.jpg";